<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
              
      <v-layout row wrap>
        <v-flex xs12 sm5>
          <v-select
            v-model="selectSupplier"
            :items="suppliers"
            label="取引先選択"
            item-text="supplierName"
            item-value="supplierCode"
            :sort-by="['supplierCode']"
            :sort-desc="[false]"
            return-object
          ></v-select>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="stores"
        class="elevation-1"
        hide-actions
        :customFilter="customFilter"
        :search="selectSupplier"
        :loading="loadingData"
      >
        <!-- :search="selectStoreCode" :filter="filter" :customFilter="customFilter" -->
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        
        <template v-slot:items="props">
          <tr @click="forwardStoreEdit(props.item)">
            <td class="text-xs-left">{{ props.item.storeCode }}</td>
            <td class="text-xs-left">{{ props.item.storeName }}</td>
            <td class="text-xs-left">{{ props.item.supplierCode }}</td>
            <td class="text-xs-left">{{ props.item.isAutoOrder }}</td>
            <td class="text-xs-center">
              <v-icon v-if="'1' === props.item.isSalesperson">how_to_reg</v-icon>
            </td>

            <td class="text-xs-center">
              <v-icon v-if="props.item.isRegistedItem">check_circle</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <br />

      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
        <v-btn block color="primary" dark @click="downloadCsv()">
          <v-icon dark left>get_app</v-icon>{{ $t('download-btn') }}
        </v-btn>
        <v-btn block color="success" dark :to="{ name: 'admin/stores/new' }">
          <v-icon dark left>create</v-icon>新規登録
        </v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'

export default {
  created() {
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    let thisObj = this
    this.loadingData = true

    // 모든 거래처 정보 가져오기
    ServerApiCallService.suppliers()
      .then(response => {
        thisObj.suppliers = response.data.suppliers

        // 리스트 박스에 추가
        thisObj.suppliers.unshift({
          supplierCode: '#',
          supplierName: '全て(使える店舗)'
        })
        
        thisObj.suppliers.splice(1,0,{
          supplierCode: 'r',
          supplierName: '使えない店舗'
        })
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      }
    )

    // 모든 점포정보 가져오기
    ServerApiCallService.stores()
      .then(response => {
        let tmpStores = response.data.stores
        
        tmpStores.forEach(function (row) {
          // 1: 자동발주 함
          if (row.isAutoOrder == '1') {
            row.isAutoOrder = '〇'
          } else {
            row.isAutoOrder = '✖'
          }
        })
        
        thisObj.stores = tmpStores

        this.loadingData = false
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (a.supplierCode < b.supplierCode) {
          return -1
        } else if (a.supplierCode > b.supplierCode) {
          return 1
        }
        if (a.storeName < b.storeName) {
          return -1
        } else if (a.storeName > b.storeName) {
          return 1
        }
        return 0
      })
      return items
    },
    customFilter(items, search) {
      if (search.supplierName === '全て(使える店舗)') {
        // 사용하는 점포만 보여주기
        let activeStores = items.filter(function(value) {
          if (value.isDeleted === '0') {
            return true;
          } else {
            return false;
          }
        })

        return activeStores
      } else if (search.supplierName === '使えない店舗') {
        // 사용하지 않는 점포만 보여주기
        let inactiveStores = items.filter(function(value) {
          if (value.isDeleted === '1') {
            return true;
          } else {
            return false;
          }
        })

        return inactiveStores
      } else {
        let filteringItems = items.filter(function(value) {
          // 선택된 거래처의 사용하는 점포만 보여주기
          if (value.supplierCode === search.supplierCode && value.isDeleted === '0') {
            return true
          } else {
            return false
          }
        })        

        return filteringItems
      }
    },
    forwardStoreEdit(storeRow) {
      let forwardName = 'admin_stores_update'
      this.$router.push({
        name: forwardName,
        params: {
          storeCode: storeRow.storeCode,
          isUpdateMode: true
        }
      })
    },
    downloadCsv() {
      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .get('/admin/stores-download', {
          responseType: 'blob'
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '店舗一覧.csv'
          link.click()
        })
    },
  },
  data() {
    return {
      loadingData: false,
      dispDeleted: 'info',
      stores: [],
      suppliers: [],
      selectSupplier: {
        supplierCode: '#',
        supplierName: '全て(使える店舗)'
      },
      headers: [
        {
          text: '店舗コード',
          align: 'left',
          value: 'storeCode',
          width: '150px',
          sortable: true,
          fixed: true
        },
        {
          text: '店舗名',
          align: 'left',
          sortable: false,
          value: 'storeName',
          width: '120px',
          fixed: true
        },
        {
          text: '取引先コード',
          align: 'left',
          sortable: false,
          value: 'supplierCode',
          width: '30px'
        },
        {
          text: '自動発注',
          align: 'left',
          sortable: false,
          value: 'isAutoOrder',
          width: '30px'
        },
        {
          text: '販売員有無',
          align: 'center',
          sortable: false,
          value: 'salesmanFlg',
          width: '30px'
        },
        {
          text: '商品登録',
          align: 'center',
          sortable: false,
          value: 'storeFlg',
          width: '100px'
        }
      ]
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
